<!--<input
  #file_input
  class="block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer focus:outline-none"
  id="file_input"
  type="file"
  (change)='loadFile($event)'
/>
-->
<div
  class="text-center p-3 relative border-4 border-dotted border-gray-300 rounded-lg"
>
  <pulse-icon
    *ngIf="!fileName"
    class="mb-2"
    icon="upload"
    size="30"
  ></pulse-icon>
  <div
    [ngClass]="{ hidden: fileName }"
    class="flex flex-col w-max mx-auto text-center"
  >
    <label class="flex">
      <input
        #fileInput
        class="text-sm cursor-pointer w-36 hidden"
        type="file"
        (change)="loadFile($event)"
      />
      <div
        class="text bg-primary-500 text-white border border-gray-300 rounded cursor-pointer p-1 px-3"
      >
        Select a file
      </div>
      <br />
    </label>
  </div>
  <div class="flex justify-between" *ngIf="fileName">
    <div>Selected file: {{ fileName }}</div>
    <pulse-icon (click)="removeFile()" icon="close"></pulse-icon>
  </div>
</div>
